import PrimaryNavigation from "../../../../src/components/docs/examples/Navigation/PrimaryNavigation";
import Breadcrumb from "../../../../src/components/docs/examples/Navigation/Breadcrumb";
import GenericNavigation from "../../../../src/components/docs/examples/Navigation/GenericNavigation";
import Justification from "../../../../src/components/docs/examples/Navigation/Justification";
import IconsInNav from "../../../../src/components/docs/examples/Navigation/IconsInNav";
import Dropdowns from "../../../../src/components/docs/examples/Navigation/Dropdowns";
import * as React from 'react';
export default {
  PrimaryNavigation,
  Breadcrumb,
  GenericNavigation,
  Justification,
  IconsInNav,
  Dropdowns,
  React
};